export const getDisplayDateFromTimestamp = (timestamp) => {
    let showDate = new Date(timestamp).toUTCString()
    showDate = showDate.substr(0, showDate.lastIndexOf(' ')) + ',' + showDate.substr(showDate.lastIndexOf(' '), showDate.length)
    return showDate.substring(showDate.indexOf(' '), showDate.length).trim()
}